<app-layout>
  <app-session-manager></app-session-manager>
</app-layout>
